/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from 'react';
import Loading from '@svb/api-loading-component/dist/components/index';

export default function HealthCheckAPI() {
  const [word, setWord] = useState('');
  const [error, setError] = useState(false);
  const [mounted, setmounted] = useState(false);

  const [token, setToken] = useState(false);
  const [tokenMsg, setTokenMsg] = useState('Online');
  //
  const [browse, setbrowse] = useState(false);
  const [browseMsg, setbrowseMsg] = useState('Online');
  //
  const [content, setcontent] = useState(false);
  const [contentMsg, setcontentMsg] = useState('Online');
  const requestContent =
    process.env.REACT_APP_CONTENT_SERVER +
    '/portal-content?resourcePath=/apis/ach-transfers/1.3&resourceName=config.json';
  let clientID = process.env.REACT_APP_CLIENT_ID || '';
  let apigeeHost = process.env.REACT_APP_APIGEE_HOST || '';
  const baseUrl = window.location.host;
    // Assign default ID and host
    // Assign based on URL
    if (baseUrl.includes('localhost')) {
      clientID = process.env.REACT_APP_LOCAL_CLIENT_ID;
      apigeeHost = process.env.REACT_APP_LOCAL_APIGEE_HOST;
    }

  const checkOnlineStatus = async (key) => {
    // build token request
    // token headers
    let tokenHeaders = new Headers();
    tokenHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    // token body params
    let tokenUrlencoded = new URLSearchParams();
      tokenUrlencoded.append("grant_type", "urn:svb:params:oauth:grant-type:anonymous");
      tokenUrlencoded.append("client_id", clientID);
    // token request-options
    let tokenrequestOptions = {
      method: 'POST',
      headers: tokenHeaders,
      body: tokenUrlencoded
    };

    // build browse request
    // browse headers
    let browseHeaders = new Headers();
      let token = localStorage.getItem('token');
      browseHeaders.append("Origin", "https://beta.dev.developer.svb.com");
      browseHeaders.append("Authorization", `Bearer ${token}`);
    // browse request
    let browseRequestOptions = {
      method: 'GET',
      headers: browseHeaders
    };
    // build content-svc request
    // content-svc headers
    let contentSvcHeaders = new Headers();
      contentSvcHeaders.append("Authorization", `${token}`);
    let contentRequestOptions = {
      headers: contentSvcHeaders
    }
    try {
      switch (key) {
        case 'browse':
          await fetch(
            `${apigeeHost}${process.env.REACT_APP_APIGEE_CATALOG_PATH}`, browseRequestOptions
          )
            .then(async (res) => {
              const data = await res.json();
              setError(false);
              setbrowseMsg(data?.message || data?.status);
              if (res.ok) {
                setWord(data);
                setError(false);
                return setWord(data);
              }

              const status = data.status.toString()[0];
              if (status === '4') {
                return setWord('Sorry, not found');
              } else if (status === '5') {
                return setWord('Could not reach the server. Please try again later');
              }
            })

            .catch((err) => {
              setError(true);
              setbrowse(true);
              setbrowseMsg(JSON.stringify(err, true));
              setbrowse(err.status >= 200 && err.status < 300);
              if (typeof err === 'object' && err.message.includes('NetworkError')) {
                setWord(err);
              } else {
                setWord(err);
              }
            });

          break;
        case 'content':
          await fetch(`${requestContent}`, contentRequestOptions)
            .then(async (res) => {
              const data = await res.json();
              setError(false);
              setcontentMsg(data?.message || data?.status);
              if (res.ok) {
                setWord(data);
                setError(false);
                return setWord(data);
              }

              const status = data.status.toString()[0];
              if (status === '4') {
                setWord('Sorry, not found');
              } else if (status === '5') {
                setWord('Could not reach the server. Please try again later');
              }
            })
            .catch((err) => {
              setError(true);
              setcontent(true);
              setcontentMsg(JSON.stringify(err, true));
              setcontent(err.status >= 200 && err.status < 300);
              if (typeof err === 'object' && err.message.includes('NetworkError')) {
                setWord(err);
              } else {
                setWord(err);
              }
            });

          break;
        case 'token':
          await fetch(
            `${apigeeHost}${process.env.REACT_APP_TOKEN_PATH}`,
            tokenrequestOptions,
          )
            .then(async (res) => {
              const data = await res.json();
              setError(false);
              setTokenMsg(data?.message || data?.status);
              if (res.ok) {
                setWord(data);
                setError(false);
                return setWord(data);
              }

              const status = data.status.toString()[0];
              if (status === '4') {
                setWord('Sorry, not found');
              } else if (status === '5') {
                setWord('Could not reach the server. Please try again later');
              }
            })

            .catch((err) => {
              setError(true);
              setToken(true);
              setTokenMsg(JSON.stringify(err, true));
              setToken(err.status >= 200 && err.status < 300);
              if (typeof err === 'object' && err.message.includes('NetworkError')) {
                setWord(err);
              } else {
                setWord(err);
              }
            });

          break;
      }
    } catch (err) {
      switch (key) {
        case 'browse':
          setbrowseMsg(JSON.stringify(err, true));
          setbrowse(true);
          break;
        case 'content':
          setcontentMsg(JSON.stringify(err, true));
          setcontent(true);
          break;
        case 'token':
          setTokenMsg(JSON.stringify(err, true));
          setToken(true);
          break;
      }
      if (typeof err === 'object' && err.message.includes('NetworkError')) {
        setWord(err);
      } else {
        setWord(err);
      }
    }
  };
  useEffect(() => {
    setToken(checkOnlineStatus('token'));
    setbrowse(checkOnlineStatus('browse'));
    setcontent(checkOnlineStatus('content'));
    setTimeout(() => {
      setmounted(true);
    }, 100);
  }, []);
  useCallback(() => {}, []);
  const handleError = useCallback((tokenMsg, contentMsg, browseMsg, word) => {
    document.title = '404';
    document.body.innerHTML = JSON.stringify({
      status: '404',
    });
  });
  const handleSuccess = useCallback((tokenMsg, contentMsg, browseMsg, word) => {
    document.title = '200';
    document.body.innerHTML = JSON.stringify({
      status: '200',
    });
  });
  //   const handleOffline = useCallback((tokenMsg, contentMsg, browseMsg, word) => {
  //     document.title = '500';
  //     document.body.innerHTML = JSON.stringify({
  //       token: tokenMsg,
  //       content: contentMsg,
  //       browse: browseMsg,
  //       message: word,
  //     });
  //   });

  return !mounted ? (
    <Loading />
  ) : error || !token || !content || !browse ? (
    handleError(tokenMsg, contentMsg, browseMsg, word)
  ) : (
    handleSuccess(tokenMsg, contentMsg, browseMsg, word)
  );
}
